import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { api } from '../services/api'

/**
 * Deep link handler: /join/:code
 *
 * If the user is already authenticated → call use-code directly.
 * If not → save code to sessionStorage and redirect to /register.
 * After register/login, RegisterPage/LoginPage should pick up the pending code.
 */
export default function JoinPage() {
  const { code } = useParams<{ code: string }>()
  const navigate = useNavigate()
  const { isAuthenticated, user } = useAuthStore()

  useEffect(() => {
    if (!code) {
      navigate('/', { replace: true })
      return
    }

    if (!isAuthenticated) {
      // Persist the code so post-auth flow can consume it
      sessionStorage.setItem('pendingLinkCode', code)
      navigate(`/register?joinCode=${code}`, { replace: true })
      return
    }

    // Already authenticated — use the code immediately if student
    if (user?.role === 'parent') {
      navigate('/', { replace: true })
      return
    }

    api.useLinkCode(code)
      .then(() => {
        sessionStorage.removeItem('pendingLinkCode')
        navigate('/?linked=1', { replace: true })
      })
      .catch(() => {
        // Code invalid or expired — go home, user can try manually
        navigate('/', { replace: true })
      })
  }, [code, isAuthenticated, user, navigate])

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: 'var(--color-bg)' }}
    >
      <p className="text-sm" style={{ color: '#64748B' }}>Verificando código de vinculación…</p>
    </div>
  )
}
